import React from 'react';
import { View } from 'react-native';
import { ModalM } from '@common/components/modal/ModalM';
import TitleM from '@common/components/text/TitleM';
import TextM from '@common/components/text/TextM';
import FilledButtonM from '@common/components/button/FilledButtonM';

/**
 * Simple modal shown when multiple tabs are detected
 * User clicks button to keep this tab and close others
 */
export const KeepTabModal = ({ isVisible, onKeepThisTab }) => {
  return (
    <ModalM
      visible={isVisible}
      dismissable={false}
      style={{ maxHeight: '90%' }}
    >
      <View style={{ paddingHorizontal: 20, paddingVertical: 24 }}>
        <View style={{ alignItems: 'center', marginBottom: 20 }}>
          <TitleM style={{ textAlign: 'center', fontSize: 20 }} fontWeight="ExtraBold">
            Plusieurs onglets détectés
          </TitleM>
        </View>

        <View style={{ marginBottom: 24 }}>
          <TextM style={{ fontSize: 15, lineHeight: 22, marginBottom: 12, textAlign: 'center' }} wrap>
            Tu as plusieurs onglets ouverts avec la même session. Clique sur le bouton ci-dessous dans l'onglet que tu souhaites garder.
          </TextM>
          <TextM style={{ fontSize: 15, lineHeight: 22, marginBottom: 12, textAlign: 'center' }} wrap>
            Les autres onglets seront automatiquement fermés.
          </TextM>
        </View>

        <View style={{ alignItems: 'center' }}>
          <FilledButtonM
            label="Garder cet onglet"
            icon="check-circle"
            onPress={onKeepThisTab}
            wrapText
          />
        </View>
      </View>
    </ModalM>
  );
};

export default KeepTabModal;
